import type { ReactNode } from "react";
import { StyleSheet, View } from "react-native";

import { AppText } from "./AppText";
import {
  radii,
  spacing,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

export function Badge({
  children,
  tone = "neutral",
}: {
  children: ReactNode;
  tone?: "neutral" | "mint" | "danger" | "warning" | "success";
}) {
  const { stylesheet, toneStyles } = useThemedStyles(makeStyles);
  return (
    <View style={[stylesheet.badge, toneStyles[tone]]}>
      <AppText size="xs" weight="semibold">
        {children}
      </AppText>
    </View>
  );
}

const makeStyles = (colors: ThemeColors) => {
  const stylesheet = StyleSheet.create({
    badge: {
      alignSelf: "flex-start",
      paddingHorizontal: spacing.s,
      paddingVertical: spacing.xs,
      borderRadius: radii.pill,
      borderWidth: 1,
    },
    neutral: {
      borderColor: colors.border,
      backgroundColor: colors.surface,
    },
    mint: {
      borderColor: colors.primary,
      backgroundColor: colors.mutedSurface,
    },
    danger: {
      borderColor: colors.danger,
      backgroundColor: colors.dangerSurface,
    },
    warning: {
      borderColor: colors.warning,
      backgroundColor: colors.warningSurface,
    },
    success: {
      borderColor: colors.success,
      backgroundColor: colors.successSurface,
    },
  });
  const toneStyles = {
    neutral: stylesheet.neutral,
    mint: stylesheet.mint,
    danger: stylesheet.danger,
    warning: stylesheet.warning,
    success: stylesheet.success,
  };
  return { stylesheet, toneStyles };
};
